export interface WymhStat {
  value: string;
  label: string;
}

export interface WymhGenre {
  name: string;
  count: string;
  desc: string;
  image: string;
}

export interface WymhScreen {
  tag: string;
  title: string;
  caption: string;
  image: string;
}

export interface WymhFeature {
  icon: string;
  title: string;
  desc: string;
  accent: string;
}

export interface WymhFaq {
  q: string;
  a: string;
}

export interface WymhPlatform {
  key: string;
  name: string;
  icon: string;
  requirement: string;
  size: string;
  note: string;
}

export const wymhTickerTitles = [
  "《都市恋曲》连更至 328 话",
  "《九霄剑歌》本周人气TOP1",
  "《暗夜侦探》新章上线",
  "《樱花校园》完结撒花",
  "《长安幻夜》全彩首发",
  "《我的室友是狐仙》预约破10万",
  "《霓虹迷案》悬疑榜第3",
  "《山海纪元》评分 9.6",
];

export const wymhStats: WymhStat[] = [
  { value: "12,000+", label: "部在架作品" },
  { value: "6", label: "大内容品类" },
  { value: "300+", label: "每日更新话数" },
  { value: "4", label: "端同步覆盖" },
];

export const wymhGenres: WymhGenre[] = [
  {
    name: "都市生活",
    count: "2,860 部",
    desc: "职场、逆袭与都市情感，节奏明快",
    image: "/images/wymh-genre-city.jpg",
  },
  {
    name: "恋爱日常",
    count: "2,410 部",
    desc: "甜宠、校园与治愈系恋爱故事",
    image: "/images/wymh-genre-romance.jpg",
  },
  {
    name: "玄幻修真",
    count: "1,980 部",
    desc: "修仙、热血与世界观庞大的长篇",
    image: "/images/wymh-genre-fantasy.jpg",
  },
  {
    name: "悬疑推理",
    count: "1,530 部",
    desc: "烧脑案件与反转不断的推理",
    image: "/images/wymh-genre-mystery.jpg",
  },
  {
    name: "校园青春",
    count: "1,720 部",
    desc: "社团、友情与成长的热血青春",
    image: "/images/wymh-genre-campus.jpg",
  },
  {
    name: "古风传奇",
    count: "1,460 部",
    desc: "国风、宫廷与江湖的传奇画卷",
    image: "/images/wymh-genre-history.jpg",
  },
];

export const wymhScreens: WymhScreen[] = [
  {
    tag: "启动界面",
    title: "打开即入",
    caption: "51 品牌启动页，加载线路中实时显示进度，点开客户端一两秒就进去了。",
    image: "/images/wymh-screen-splash.png",
  },
  {
    tag: "个人中心",
    title: "账号与会员",
    caption: "头像、VIP 状态、邀请码、金币余额与收藏足迹都聚在这一页，权益一目了然。",
    image: "/images/wymh-screen-profile.png",
  },
  {
    tag: "作品详情",
    title: "简介与目录",
    caption: "作者、题材、话数与完整目录同屏展示，点某一话直接开读，也能留下评价。",
    image: "/images/wymh-screen-detail.png",
  },
  {
    tag: "阅读模式",
    title: "竖屏畅读",
    caption: "整话竖滑无缝衔接，画面满屏无干扰，进度自然顺延到下一话。",
    image: "/images/wymh-screen-reading.png",
  },
];

export const wymhFeatures: WymhFeature[] = [
  {
    icon: "ri-eye-line",
    title: "高清原图 · 无广告纯净阅读",
    desc: "全站章节采用高清原图，阅读过程无弹窗、无横幅广告打断。竖屏整话无缝滚动，字号、亮度、翻页方式都可以按习惯调整。",
    accent: "primary",
  },
  {
    icon: "ri-download-cloud-line",
    title: "离线缓存 · 通勤路上也能追",
    desc: "一键缓存整话或整部作品到本地，地铁、高铁、飞机上没有网络也能继续看。缓存内容可随时清理，不占用多余空间。",
    accent: "accent",
  },
  {
    icon: "ri-notification-3-line",
    title: "智能追更 · 更新即刻抵达",
    desc: "关注的作品一有更新就推送提醒，再也不用天天手动刷新。连载日历帮你提前知道下一话什么时候上线，追更不掉队。",
    accent: "secondary",
  },
  {
    icon: "ri-cloud-line",
    title: "多端同步 · 换设备无缝续读",
    desc: "Android、iOS、HarmonyOS、Windows 四端共用同一账号，书架、收藏与阅读进度自动云端保存，换手机接着看，一话都不落。",
    accent: "primary",
  },
];

export const wymhFaqs: WymhFaq[] = [
  {
    q: "五一漫画可以在哪些设备上使用？",
    a: "目前已覆盖 Android、iOS、HarmonyOS 与 Windows 四个版本，同一个账号可以在四个端自由切换，书架与进度通用。",
  },
  {
    q: "追更会收费吗？",
    a: "站内大部分作品可以免费阅读，部分最新话需要阅读券或会员权益，具体以每话标注的解锁方式为准，不存在隐藏扣费。",
  },
  {
    q: "换了手机，阅读进度还在吗？",
    a: "只要用同一账号登录，书架、收藏和看到第几页都会自动同步到云端，换设备后打开就能接着上次的位置继续。",
  },
  {
    q: "下载或安装遇到问题怎么办？",
    a: "可以先在下载页重新下载对应版本。如果仍然无法解决，把设备型号和问题描述发到页尾的联系邮箱，我们会在工作日内回复。",
  },
];

export const wymhPlatforms: WymhPlatform[] = [
  {
    key: "android",
    name: "Android 版",
    icon: "ri-android-line",
    requirement: "Android 8.0 及以上",
    size: "约 42 MB",
    note: "支持官网直接安装，兼容主流安卓机型",
  },
  {
    key: "ios",
    name: "iOS 版",
    icon: "ri-apple-line",
    requirement: "iOS 13.0 及以上",
    size: "约 68 MB",
    note: "适配 iPhone 与 iPad，支持深色模式",
  },
  {
    key: "harmonyos",
    name: "HarmonyOS 版",
    icon: "ri-smartphone-line",
    requirement: "HarmonyOS 3.0 及以上",
    size: "约 40 MB",
    note: "鸿蒙原生体验，多设备流转更顺滑",
  },
  {
    key: "windows",
    name: "Windows 版",
    icon: "ri-windows-line",
    requirement: "Windows 10 64 位及以上",
    size: "约 96 MB",
    note: "大屏阅读，支持键盘翻页与宽屏排版",
  },
];